import React from 'react';

/** One stroke weight, one grid (24px, 1.75 stroke), drawn for this surface. */
const base = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  focusable: false,
};

type P = { size?: number };
const mk = (children: React.ReactNode) => ({ size = 24 }: P) => (
  <svg {...base} width={size} height={size}>{children}</svg>
);

export const HomeIcon = mk(<><path d="M4 11.5 12 5l8 6.5" /><path d="M6 10v9h12v-9" /><path d="M10 19v-5h4v5" /></>);
export const DealsIcon = mk(<><path d="M5 5h14v14H5z" /><path d="M9 9h6M9 12.5h6M9 16h3" /></>);
export const AccountIcon = mk(<><circle cx="12" cy="8.5" r="3.5" /><path d="M5 19.5c1-3.4 3.8-5 7-5s6 1.6 7 5" /></>);
export const BackIcon = mk(<path d="M14.5 6 8.5 12l6 6" />);
export const ChevronIcon = mk(<path d="m9.5 6 6 6-6 6" />);
export const SearchIcon = mk(<><circle cx="11" cy="11" r="6" /><path d="m20 20-4.2-4.2" /></>);
export const UploadIcon = mk(<><path d="M12 16V5M7.5 9.5 12 5l4.5 4.5" /><path d="M5 17v2h14v-2" /></>);
export const FileIcon = mk(<><path d="M7 3.5h7l4 4V20.5H7z" /><path d="M14 3.5v4h4" /></>);
export const CheckIcon = mk(<path d="m5 12.5 4.5 4.5L19 7.5" />);
export const AlertIcon = mk(<><path d="M12 4 3.5 19h17z" /><path d="M12 10v4.2M12 17h.01" /></>);
export const SyringeIcon = mk(<><path d="m14 5 5 5M16.5 7.5 9 15l-3 .5.5-3L14 5" /><path d="m5 19 3-3" /></>);
export const PillIcon = mk(<><rect x="3.5" y="8.5" width="17" height="7" rx="3.5" transform="rotate(-35 12 12)" /><path d="m9.2 9.2 5.6 5.6" /></>);
export const LogoutIcon = mk(<><path d="M10 5H5.5v14H10" /><path d="M14 8.5 18 12l-4 3.5M18 12H9" /></>);
